import { render } from "./ContactComplete.vue?vue&type=template&id=6ab29f28"
const script = {}

import exportComponent from "/codebuild/output/src1111083459/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__